import { forwardRef, memo, type Ref } from 'react';
import { FormDropdown } from '~/commonComponents/FormDropdown';
import { DropdownOption } from '~/commonComponents/FormDropdown/DropdownOption';
import { getShouldOfficeShowEfda } from '~/growthbook';
import { useAppSelector } from '~/hooks/useAppSelector';
import { getAllProfessionTypeOptions } from '~/utils/DentistUtils';

interface IProfessionalTypeFieldProps {
  value?: string;
  onChange?: (value: string) => void;
  isOpen: boolean;
  onToggle: () => void;
}

const Component = (
  { value, onChange, isOpen, onToggle }: IProfessionalTypeFieldProps,
  ref: Ref<HTMLDivElement>,
) => {
  const allProfessions = useAppSelector((state) => state.user.allProfessions);
  const showEfda = getShouldOfficeShowEfda();
  const professionOptions = getAllProfessionTypeOptions(allProfessions, { showEfda });

  return (
    <div ref={ref}>
      <FormDropdown
        label="Professional Type"
        value={value || undefined}
        isOpen={isOpen}
        onToggle={onToggle}
        testId="professional-type-field"
      >
        {professionOptions.map((option: { code: string; name: string }) => (
          <DropdownOption
            key={option.code}
            isSelected={value === option.name}
            onSelect={() => {
              onChange?.(option.name);
              onToggle();
            }}
            testId={`profession-option-${option.code}`}
          >
            {option.name}
          </DropdownOption>
        ))}
      </FormDropdown>
    </div>
  );
};

export const ProfessionalTypeField = memo(forwardRef(Component));
